"use client"

import Image from "next/image";
import Link from "next/link";
import AnimatedSection from "../ui/AnimatedSection";
import { portfolioProjects } from "@/constants";
import { Button } from "../ui/button";
import { FaGithub } from "react-icons/fa";


export default function Portfolio() {
  return (
    // <AnimatedSection className="mt-20 sm:mt-24 lg:mt-32">
    <div className="mt-20 sm:mt-24 lg:mt-32">
      <div className="text-center mb-12 sm:mb-16" id="portifolio">
        <Image
          src="/images/img_6625065aaabd00c_white_a700_60x56.svg"
          alt="Portfolio Icon"
          width={56}
          height={60}
          className="w-12 sm:w-14 h-12 sm:h-15 mx-auto mb-4"
        />
        <p className=" font-medium text-base text-foreground/40 uppercase tracking-wider mb-2">
          PORTFOLIO SECTION
        </p>
        <h2 className=" font-medium text-4xl sm:text-5xl lg:text-[52px] text-foreground leading-tight">
          Some of my projects...
        </h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">


      {portfolioProjects.map((project, index) => (
        <Link key={index} href={project.link} target="_blank">
          <div className="bg-secondary rounded-[20px] p-6 sm:p-8 transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg cursor-pointer">
            
            <div className="flex justify-between items-center mb-6">
              <div>
                <Button variant="secondary" size="sm" className="mb-4">
                  {project.category}
                </Button>
                <h3 className="font-medium text-xl sm:text-2xl text-foreground">
                  {project.title}
                </h3>
              </div>

              {/* Right-side icons */}
              <div className="flex items-center gap-3">

                {/* GitHub link */}
                {project.github && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()} // prevents triggering parent Link
                    className="text-lg hover:text-primary transition"
                  >
                    <FaGithub style={{ color: "white", fontSize: "24px" }} />
                  </a>
                )}
                {/* Main link icon */}
                <span className="text-sm">🔗</span>
              </div>
            </div>

            <Image
              src={project.image}
              alt={project.title}
              width={536}
              height={390}
              className="w-full h-auto rounded-[16px]"
            />
          </div>
        </Link>
      ))}

      </div>
      <div className="text-center mt-12 sm:mt-16">
        <a
          href="https://github.com/fiacredev"
          className="inline-block bg-primary text-foreground  font-medium rounded-full transition-all duration-300 transform hover:-translate-y-1 px-8 py-4 text-lg"
        >
          Github
        </a>
      </div>
      </div>
    
  );
}
